import ko from 'knockout';
import { antiForgeryPost } from '../../../utils/fetch';

function WishListViewModel(items) {
    this.items = ko.observableArray(items);
}

WishListViewModel.prototype.hasItems = function () {
    return this.items().length > 0;
};

WishListViewModel.prototype.addItem = function (item) {
    this.items.push(item);
};

WishListViewModel.prototype.removeItem = function (item) {
    const index = this.items.indexOf(item);
    const restoreItem = () => this.items.splice(index, 0, item);

    this.items.remove(item);

    return utils.post(`/api/wishlist/removewishlistitem/${item.WishListItemId}`)
        .catch(() => restoreItem());
};

WishListViewModel.prototype.addItemToCart = function (item) {
    const index = this.items.indexOf(item);
    const restoreItem = () => this.items.splice(index, 0, item);

    this.items.remove(item);

    if (!item.CanAddToCart) {
        return utils.post(`/cart/AddWishListItemToCart?wishListItemId=${item.WishListItemId}&redirectUrl=${encodeURIComponent(item.LinkUrl)}`)
            .catch(() => restoreItem());
    }

    return utils.post(`/api/wishlist/addwishlistitemtocart/${item.WishListItemId}`)
        .catch(() => restoreItem());
};

WishListViewModel.prototype.update = function(items) {
    this.items(items);
};

function post(url) {
    return antiForgeryPost(url)
        .then(response => response.json());
}

export default WishListViewModel;

export const utils = {
    post
};